import { defineMessages } from "react-intl"

export default defineMessages({
	transfer_desc: {
		id: "app.transfers.transfer_desc",
		defaultMessage:
			"Make instant transfers of assets between  BTC-Alpha user accounts. No fees, convenient and most importantly – safe!",
	},
	create_transfer: {
		id: "app.transfers.create_transfer",
		defaultMessage: "Create Transfer",
	},
	transfer_created: {
		id: "app.transfers.transfer_created",
		defaultMessage: "Transfer accepted",
	},
	transfer_creation: {
		id: "app.transfers.transfer_creation",
		defaultMessage: "Transfer creation",
	},
	transfer_confirming: {
		id: "app.transfers.transfer_confirming",
		defaultMessage: "Transfer confirming",
	},
	transfer_confirmed: {
		id: "app.transfers.transfer_confirmed",
		defaultMessage: "Transfer confirmed",
	},
	transfer_canceled: {
		id: "app.transfers.transfer_canceled",
		defaultMessage: "Transfer canceled",
	},
	history_header: {
		id: "app.transfers.history_header",
		defaultMessage: "History of Transfers",
	},
	history_status_10: {
		id: "app.transfers.history_status_10",
		defaultMessage: "Pending",
	},
	history_status_20: {
		id: "app.transfers.history_status_20",
		defaultMessage: "Cancel",
	},
	history_status_30: {
		id: "app.transfers.history_status_30",
		defaultMessage: "Success",
	},
	transfer_sent_activation: {
		id: "app.transfers.transfer_sent_activation",
		defaultMessage: "Sent. Awaiting activation",
	},
	transfer_received_activation: {
		id: "app.transfers.transfer_received_activation",
		defaultMessage: "Received. Awaiting activation",
	},
	check_transfer: {
		id: "app.transfers.check_transfer",
		defaultMessage:
			"Please check the transfer details. If you notice an error click the Back button",
	},
	transfer_active_time: {
		id: "app.transfers.transfer_active_time",
		defaultMessage: "Transfer active",
	},
	transfer_sent: {
		id: "app.transfers.transfer_sent",
		defaultMessage: "Transfer sent",
	},
	secure_transfer_msg: {
		id: "app.transfers.secure_transfer_msg",
		defaultMessage:
			"If the transfer is not accepted within the specified period , you will be able to return the funds to your balance.",
	},
	secure_transfer_warn: {
		id: "app.transfers.secure_transfer_warn",
		defaultMessage:
			"For security reasons, we do not store the security code you provide. Please save your security code before confirming the transfer",
	},
	secure_transfer_await_receiver: {
		id: "app.transfers.secure_transfer_await_receiver",
		defaultMessage: "Activation is expected on the recipient's side",
	},
	transfer_receiving: {
		id: "app.transfers.transfer_receiving",
		defaultMessage: "You have received a transfer",
	},
	transfer_receiving_desc: {
		id: "app.transfers.transfer_receiving_desc",
		defaultMessage: "You have received a transfer. To get it enter the security code",
	},
	transfer_secure_desc_date: {
		id: "app.transfers.transfer_secure_desc_date",
		defaultMessage:
			"If the transfer is not accepted within the active days, the funds will be automatically returned to the sender's account.",
	},
	add_security_code: {
		id: "app.transfers.add_security_code",
		defaultMessage: "Add a security code",
	},
	security_code: {
		id: "app.transfers.security_code",
		defaultMessage: "Security Code",
	},
	days_active: {
		id: "app.transfers.days_active",
		defaultMessage: "Days active",
	},
	description: {
		id: "app.transfers.description",
		defaultMessage: "Description",
	},
	add_note: {
		id: "app.transfers.add_note",
		defaultMessage: "Add a note",
	},
	transfer_from: {
		id: "app.transfers.transfer_from",
		defaultMessage: "Transfer from",
	},
	transfer_to: {
		id: "app.transfers.transfer_to",
		defaultMessage: "Transfer to",
	},
	transfers_history: {
		id: "app.containers.transfers.transfers_history",
		defaultMessage: "Transfers history",
	},
	quantity: {
		id: "app.containers.transfers.quantity",
		defaultMessage: "Quantity",
	},
	date_and_time: {
		id: "app.containers.transfers.date_and_time",
		defaultMessage: "Date & Time",
	},
	coin: {
		id: "app.containers.transfers.coin",
		defaultMessage: "Coin",
	},
	no_orders_to_show: {
		id: "app.containers.transfers.no_orders_to_show",
		defaultMessage: "No orders to show.",
	},
	transfers: {
		id: "app.containers.transfers.transfers",
		defaultMessage: "Transfers",
	},
	confirm_to_transfer: {
		id: "app.containers.transfers.confirm_to_transfer",
		defaultMessage: "Confirm to Transfer",
	},
	email_verification: {
		id: "app.containers.transfers.email_verification",
		defaultMessage: "Email Verification",
	},
	google_2fa: {
		id: "app.containers.transfers.google_2fa",
		defaultMessage: "Google-2fa",
	},
	help_center: {
		id: "app.containers.transfers.help_center",
		defaultMessage: "Help Center",
	},
	select_coin_to_transfer: {
		id: "app.containers.transfers.select_coin_to_transfer",
		defaultMessage: "Select coin to transfer",
	},
	select_coin: {
		id: "app.containers.transfers.select_coin",
		defaultMessage: "Select Coin",
	},
	maximum_amount: {
		id: "app.containers.transfers.maximum_amount",
		defaultMessage: "Maximum: {value} {currency}",
	},
	optional_details: {
		id: "app.containers.transfers.optional_details",
		defaultMessage: "Optional details",
	},
	type_anything_you_want: {
		id: "app.containers.transfers.type_anything_you_want",
		defaultMessage: "Type anything you want",
	},
	confirm_transfer: {
		id: "app.containers.transfers.confirm_transfer",
		defaultMessage: "Confirm Transfer",
	},
  received_successfully: {
		id: "app.containers.transfers.received_successfully",
		defaultMessage: "Received successfully",
	},
  success_transfer: {
    id: "app.containers.transfers.success_transfer",
    defaultMessage: "Success Transfer",
  },
  transfer_processed_successfully: {
		id: "app.containers.transfers.transfer_processed_successfully",
		defaultMessage: "Transfer processed successfully.",
	},
  received_amount_will_equal: {
		id: "app.containers.transfers.received_amount_will_equal",
		defaultMessage: "The received amount will equal your entered transfer amount.",
	},
})
